import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5ab77c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setting-panel transimission-settings" }
const _hoisted_2 = { class: "panel-section" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-title" }, " 下载速度设置 ", -1))
const _hoisted_4 = { class: "section-content" }
const _hoisted_5 = { class: "setting-box speed-setting" }
const _hoisted_6 = { class: "panel-section" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-title" }, "同时下载任务", -1))
const _hoisted_8 = { class: "section-content" }
const _hoisted_9 = { class: "setting-box concurrent-setting" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-title" }, " 同时下载任务数 ", -1))
const _hoisted_11 = { class: "setting-inputbox" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "setting-box autodownload-setting" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "设备开机自启下载任务"),
  /*#__PURE__*/_createElementVNode("p", null, "开启后盒子设备开机后，将自动开始下载进行中任务。暂停或失败状态的任务将不受影响。")
], -1))

import { ref, computed, watchEffect } from 'vue'
// import SettingItem from '@remote/components/SettingItem.vue'
import SpeedSetting from '@remote/components/SpeedSetting.vue'
import Switch from '@remote/components/switchbox/Switch.vue'
import SVGIcon from '@remote/components/SVGIcon.vue'
import { debounce } from 'lodash'
import { useHeziTransportSettingStore } from '@remote/store/settings'
import { checkState } from '@remote/store/utils'
import { getErrorMessage } from '@remote/utils/base'
import { toast } from '@remote/utils/dialog'
import type { TTransportConfig } from '@remote/api/adapter/shell-mqtt'

type TTransportSetting = Pick<TTransportConfig, 'concurrent_downloads' | 'download_speed_limit'>

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

function logs (..._args) {
  console.log('[设置]', ..._args)
}

const { state: transportSettingState, toggleAutoDownload, updateTransportSettings } = useHeziTransportSettingStore()
const isAutoDownload = computed(() => transportSettingState.is_auto_download)
const transportConfig = computed<TTransportSetting>(() => ({
  concurrent_downloads: transportSettingState.concurrent_downloads,
  download_speed_limit: transportSettingState.download_speed_limit,
}))

const onDownloadSpeedSettingChange = debounce((setting: Pick<TTransportConfig, 'download_speed_limit'>) => {
  if (checkState(true, true, false)) return
  logs('[下载速度设置]:', setting)
  updateTransportSettings(setting).catch(err => {
    const msg = getErrorMessage(err)
    toast({ type: 'error', message: msg || '设置失败' })
  })
}, 1000, { leading: false, trailing: true })

const concurrentDownloads = ref(String(transportSettingState.concurrent_downloads))
const canIncrease = computed(() => +concurrentDownloads.value < transportSettingState.concurrent_download_limit)
const canDecrease = computed(() => +concurrentDownloads.value > 1)
// 防抖设置同时下载数
const setConcurrentDownloadNumber = debounce((setting: Pick<TTransportConfig, 'concurrent_downloads'>) => {
  if (checkState(true, true, false)) return
  logs('[同时下载数设置]:', setting)
  concurrentDownloads.value = String(setting.concurrent_downloads)
  updateTransportSettings(setting).catch(err => {
    const msg = getErrorMessage(err)
    toast({ type: 'error', message: msg || '设置失败' })
  })
}, 1000, { leading: false, trailing: true })
// 同时下载数+1
function increaseConcurrentDownloads () {
  const num = +concurrentDownloads.value + 1
  logs('[同时下载数 +1]:', num)
  const limit = transportSettingState.concurrent_download_limit
  if (num < 1 || num > limit) return
  if (checkState(true, true, false)) return
  const number = num || transportSettingState.concurrent_downloads
  const setting = { concurrent_downloads: Math.min(limit, number) }
  concurrentDownloads.value = String(setting.concurrent_downloads)
  logs('[同时下载数修改]:', num, setting.concurrent_downloads)
  setConcurrentDownloadNumber(setting)
}
// 同时下载数-1
function decreaseConcurrentDownloads () {
  const num = +concurrentDownloads.value - 1
  logs('[同时下载数 -1]:', num)
  const limit = transportSettingState.concurrent_download_limit
  if (num < 1 || num > limit) return
  if (checkState(true, true, false)) return
  const number = num || transportSettingState.concurrent_downloads
  const setting = { concurrent_downloads: Math.min(limit, number) }
  concurrentDownloads.value = String(setting.concurrent_downloads)
  logs('[同时下载数修改]:', num, setting.concurrent_downloads)
  setConcurrentDownloadNumber(setting)
}
function onConcurrentDownloadInputChange (event: InputEvent) {
  // const prevValue = concurrentDownloads.value
  if (checkState(true, true, false)) return
  const value = (event.target as HTMLInputElement).value.trim().replace(/\D/g, '')
  concurrentDownloads.value = value
}
// 输入框失焦，调用接口进行设置
function onConcurrentDownloadInputBlur () {
  const current = parseInt(concurrentDownloads.value, 10)
  if (isNaN(current)) {
    concurrentDownloads.value = String(transportSettingState.concurrent_downloads)
    return
  }
  const limit = transportSettingState.concurrent_download_limit
  const number = current <= 0 ? 1 : Math.min(limit, current)
  const setting = { concurrent_downloads: number }
  concurrentDownloads.value = String(setting.concurrent_downloads)
  logs('[同时下载数失焦修改]:', setting.concurrent_downloads)
  setConcurrentDownloadNumber(setting)
}
watchEffect(() => {
  concurrentDownloads.value = String(transportSettingState.concurrent_downloads)
})

const handleOnToggleAutoDownload = () => {
  if (checkState(true, false, false)) return

  toggleAutoDownload().catch(err => {
    console.error(err)
    const msg = getErrorMessage(err)
    toast({ type: 'error', message: msg || '设置失败' })
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(SpeedSetting, {
            "speed-limit": _unref(transportConfig).download_speed_limit,
            onSetSpeed: _unref(onDownloadSpeedSettingChange),
            onChange: _unref(onDownloadSpeedSettingChange)
          }, null, 8, ["speed-limit", "onSetSpeed", "onChange"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", {
              class: "concurrent-icon concurrent-minus",
              onClick: decreaseConcurrentDownloads,
              disabled: !_unref(canDecrease)
            }, [
              _createVNode(SVGIcon, { name: "minus-circle" })
            ], 8, _hoisted_12),
            _createElementVNode("input", {
              class: "concurrent-input",
              value: concurrentDownloads.value,
              onInput: onConcurrentDownloadInputChange,
              onBlur: onConcurrentDownloadInputBlur
            }, null, 40, _hoisted_13),
            _createElementVNode("span", {
              class: "concurrent-icon concurrent-plus",
              onClick: increaseConcurrentDownloads,
              disabled: !_unref(canIncrease)
            }, [
              _createVNode(SVGIcon, { name: "plus-circle" })
            ], 8, _hoisted_14)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", {
            class: "setting-switchbox",
            onClick: handleOnToggleAutoDownload
          }, [
            _createVNode(Switch, { value: _unref(isAutoDownload) }, null, 8, ["value"])
          ])
        ])
      ])
    ])
  ]))
}
}

})